import React, { useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Scrollbars } from "react-custom-scrollbars";
import Context from "../../Context";
export default function Scrollpane(props) {
  const cx = useContext(Context);

  const renderView = ({ style, ...props }) => {
    const viewStyle = {
      paddingRight: 12,
    };
    return (
      <div className="box" style={{ ...style, ...viewStyle }} {...props} />
    );
  };

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: "10px",
      background: `rgba(0,0,0,0.1)`,
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  return (
    <div
      className="scrollpane-container"
      style={{
        height: cx.screenAreaHeight,
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Scrollbars
        renderView={renderView}
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
      >
        {props.children}
      </Scrollbars>
      {/** 
      <PerfectScrollbar options={{ swipeEasing: true, suppressScrollX: true }}>
        {props.children}
      </PerfectScrollbar>
      */}
    </div>
  );
}
